<template>
  <NuxtLayout :name="layout">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import { useMyStoreStore } from '@/stores/myStore'

const route = useRoute()
const myStoreStore = useMyStoreStore()
const runtimeConfig = useRuntimeConfig()

const layout = computed(() => {
  if (route.name === "iframe") {
    return "iframe";
  } else if (route.name === "preview-chirashi" || route.name === "preview-viewer") {
    return "preview";
  }
  return "default";
})

// SAVE ACTIVEMYSTOREID FROM LOCAL STORAGE TO STORE
if (route.name !== 'iframe') {
  const storageId = localStorage.getItem(`${runtimeConfig.public.chainKey}-active-mystore-id`)
  if (storageId) {
    myStoreStore.$patch({ activeMyStoreId: storageId })
  } else {
    myStoreStore.$patch({ activeMyStoreId: null })
  }
}
</script>
